import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import './BussinessDetails.css';
import Footer from "../../Footer";
import { Link, useNavigate, useParams } from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';
import Topbar from "../../Topbar";
import API from '../../../Utils/Api';
import loader from '../../../assests/loader.gif';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { gettoastsuccess } from '../../../Utils/Common';
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "300px",
};

const BussinessDetails = () => {

    const navigate = useNavigate();

    const { id } = useParams();
    const [id11] = useState(id);

    const [loading, setLoading] = useState(true);

    const [inputs, setInputs] = useState({ business_name: '', town_name: '', pincode: '', business_email: '', business_contact_number: '', business_status: '', description: '',address:'',latitude:'',longitude:'' });

    const [cat, setCat] = useState([]);

    const [hoursofoperation, setHoursofoperation] = useState([]);

    const [deal, setDeal] = useState([]);

    const [images, setImages] = useState([]);

    const [center, setCenter] = useState({
    lat: null,
    lng: null,
  });


    const [current_page, setCurrentpage] = useState(1);
    const [last_page, setLastpage] = useState(1);


    //const [inputslnk, setInputslnk] = useState({ url: '' });


    var adsetting = {
        dots: true,
        arrow: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,              // Enable autoplay
        autoplaySpeed: 3000,         // Set the speed for autoplay (in milliseconds)
        centerMode: false,
        adaptiveHeight: true,            // Enable center mode    
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 1,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    };

    useEffect(() => {
        document.title = `Bussiness Details | Local Bells`;
        document.getElementById('bodywrap').className = 'nebusdet nebusdetshare';

        localStorage.setItem("page", 0);

        if (id11) {
            /*var url = process.env.REACT_APP_BASE_URL + 'neighbour/business-details/' + id11;
            setInputslnk({ url: url });*/

            let formData1 = new FormData();
            formData1.append(`business_id`, id11);
            formData1.append(`per_page`, 8);
            var url1 = 'get_neighbour_business_detail_without_login';
            if (localStorage.getItem("token")) {
                url1 = 'get_neighbour_business_detail_with_login';
            }
            API.post(url1, formData1)
                .then(response => {
                    setLoading(false);
                    if (response.data.status === false) {

                    } else {
                        setInputs({
                            business_name: response.data.data.business_name,
                            town_name: response.data.data.town_name,
                            pincode: response.data.data.pincode,
                            business_email: response.data.data.business_email,
                            business_contact_number: response.data.data.business_contact_number,
                            business_status: response.data.data.business_status,
                            description: response.data.data.description,
                            address:response.data.data.address,
                            latitude:response.data.data.latitude,
                            longitude:response.data.data.longitude,
                        });
                        if(response.data.data.latitude!=='' && response.data.data.longitude!=='')
                        {
                            setCenter({
                                lat: parseFloat(response.data.data.latitude),
                                lng: parseFloat(response.data.data.longitude),
                              });
                        }
                        setImages(response.data.data.profile);
                        setLastpage(response.data.data.pagination.last_page);
                        setCat(response.data.data.categories);
                        setHoursofoperation(response.data.data.hoursOfOperation);
                        setDeal(response.data.data.deal);
                    }
                }).catch(error => {
                    setLoading(false);
                });
        }

    }, [id11]);

    //const [isOpen, setIsOpen] = useState(false);

    /*const toggleDropdown = (e) => {
        e.preventDefault(); // Prevent navigation since <Link to="" />
        setIsOpen(!isOpen);
    };*/

    const getdeal = () => {
        setLoading(true);
        var currentpage = current_page + 1;
        let formData = new FormData();
        formData.append(`business_id`, id);
        formData.append(`per_page`, 8);
        formData.append(`page`, currentpage);
        var url = 'get_neighbour_business_detail_without_login';
        if (localStorage.getItem("token")) {
            url = 'get_neighbour_business_detail_with_login';
        }
        API.post(url, formData)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {

                } else {
                    setCurrentpage(currentpage);
                    setLastpage(response.data.data.pagination.last_page);
                    setDeal(prevDeals => [...prevDeals, ...response.data.data.deal]);
                }
            }).catch(error => {
                setLoading(false);
            });
    }

    const shareAll = () => {
        const url = window.location.href;

        navigator.clipboard.writeText(url)
            .then(() => {
                gettoastsuccess('Link copied to clipboard', '');
            })
            .catch(err => {
                console.error('Failed to copy:', err);
            });
    }

    const handleLikeDislike = (eventKey, dealId, type) => {

        if (!localStorage.getItem("token")) {
            navigate('/neighbour/login');
            return;
        }

        let formData = new FormData();
        formData.append('deal_id', dealId);
        formData.append('type', type);
        formData.append('like_dislike_id', eventKey);
        var url = 'deal_like_dislike_by_user';

        API.post(url, formData)
            .then(response => {
                if (response.data.status === false) {

                } else {
                    // console.log('Like success '+ response.data.data.total_like);
                    // console.log('Dislike success '+ response.data.data.total_dis_like);

                    setDeal(prevDeals =>
                        prevDeals.map(deal =>
                            deal.deal_id === dealId
                                ? {
                                    ...deal,
                                    is_liked: response.data.data.is_liked,
                                    is_dis_liked: response.data.data.is_dis_liked,
                                    total_like: response.data.data.total_like,
                                    total_dis_like: response.data.data.total_dis_like,
                                    like: response.data.data.like,
                                    dislike: response.data.data.dislike,
                                }
                                : deal
                        )
                    );

                }
            }).catch(error => {
                setLoading(false);
                console.error('Error :', error);
            });
    };

    const handleCopy = () => {
            const url = inputs.business_contact_number;
    
            navigator.clipboard.writeText(url)
                .then(() => {
                    gettoastsuccess('Business contact copied to clipboard', '');
                })
                .catch(err => {
                    console.error('Failed to copy:', err);
                });
        }
    
        const handleWhatapp = () => {
            const url = window.location.href;
    
            const phoneNumber = '+91'+inputs.business_contact_number;
            const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(url)}`;
    
            window.open(whatsappURL, "_blank");
        }

    return (
        <>
            <Topbar />
            <section className="main-cont-box">
                <Container>
                    <Row>
                        {/*<NeighbourSidebar isVisible={isSidebarVisible} setIsVisible={setIsSidebarVisible} />*/}
                        <Col md={12} lg={12} xl={12} xxl={12} className='main-cont-box-right'>
                            {/*<Header toggleSidebar={toggleSidebar} />*/}
                            <div className='nei-cont nei-cont-bus-share'>
{/* new design */}

                                <Row>
                                    <Col md={12} lg={12} xl={6} className='bd-box-main'>
                                        <div className='bd-top-box'>
                                            <div>
                                                <div className='bd-top-single'>
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/locpin.webp'} className="img-fluid" alt="locpin" />
                                                    <h6>{inputs.town_name} {inputs.pincode}</h6>
                                                </div>
                                            </div>
                                            <div className='d-flex flex-end'>
                                                <div className='bd-top-single'>
                                                    <Link to={`tel:${inputs.business_contact_number}`}>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/call.webp'} className="img-fluid" alt="call" />
                                                        <h6>Call</h6>
                                                    </Link>
                                                </div>
                                                <div className='bd-top-single ms-3'>
                                                    <Link to="#" onClick={handleWhatapp}>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/whatsapp-round.webp'} className="img-fluid" alt="whatsapp-round" />
                                                        <h6>WhatsApp</h6>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                        <h3 className='bd-top-title'>{inputs.business_name}</h3>
                                        <div className='bd-category'>
                                            <div>
                                                {cat.map((val1, index1) => {
                                                    return (
                                                        <h6>{val1.name}</h6>
                                                    );
                                                })}
                                            </div>
                                        </div>

                                        {images && images.length > 0 ? (
                                            <div className='share-bd-main'>
                                                <Link to="#" onClick={shareAll} className='blue-icn-btn share-bd share-bd-new'><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/share-th.webp'} className="img-fluid" alt="share-wh" /> </Link>
                                                {/*<Image src={process.env.REACT_APP_BASE_URL + 'assets/images/dashboard.webp'} className="img-fluid bd-banner" alt="dashboard" />*/}

                                                <Slider {...adsetting} className="slider-bus">
                                                    {images.map((val1, index1) => {
                                                        return (
                                                            <Image src={val1.name} className="img-fluid bd-banner" alt="ad-banner" />
                                                        );
                                                    })}
                                                </Slider>
                                            </div>
                                        ) : (
                                            <div className='share-bd-main'>
                                                <Link
                                                    to="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        shareAll();
                                                    }}
                                                    className='blue-icn-btn share-bd share-bd-new'
                                                >
                                                    <Image
                                                        src={process.env.REACT_APP_BASE_URL + 'assets/images/share-th.webp'}
                                                        className="img-fluid"
                                                        alt="share"
                                                    />
                                                </Link>

                                                <Image
                                                    src={process.env.REACT_APP_BASE_URL + 'assets/images/nif.jpg'}
                                                    className="img-fluid bd-banner bd-banner-place"
                                                    alt="dashboard"
                                                />
                                            </div>
                                        )}    

                                        <h4 className='my-3'>About Us</h4>
                                        <div className='bd-description'>
                                            <div dangerouslySetInnerHTML={{ __html: inputs.description }} />
                                            
                                        </div>
                                        <div className="d-none d-sm-block">
                                        <h4 className='my-3'>Contact Us</h4>

                                        <div className='bd-cont-single'>
                                            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/location.webp'} className="img-fluid" alt="location" />
                                            <p>{inputs.address}</p>
                                        </div>

                                        <div className='bd-cont-single'>
                                            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/email.webp'} className="img-fluid" alt="email" />    
                                            <p>{inputs.business_email}</p>
                                        </div>

                                        <div className='bd-cont-single'>
                                            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/phone.webp'} className="img-fluid" alt="phone" />
                                            <p>{inputs.business_contact_number}</p>
                                        </div>                                                                                

                                        <div className='bd-copy'>
                                            <Link to="#" onClick={handleCopy}>
                                                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/copy.webp'} className="img-fluid" alt="copy" />
                                                <p>Copy</p>
                                            </Link>
                                        </div>
                                       
                                        
                                        
                                        
                                        
                                        
                                        {inputs.latitude && inputs.longitude && (
                                          <>
                                            <h4 className="my-3">Map and Direction</h4>

                                            <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_API_KEY}>
                                              <GoogleMap
                                                mapContainerStyle={containerStyle}
                                                center={center}
                                                zoom={15}
                                              >
                                                <Marker position={center} />
                                              </GoogleMap>
                                            </LoadScript>
                                          </>
                                        )}


                                        {hoursofoperation.length > 0 && (
                                              <>
                                                <h4 className='my-3'>Hours of Operation</h4>

                                                    {hoursofoperation.map((item, index) => {
                                                      const today = new Date()
                                                        .toLocaleString("en-US", { weekday: "short" })
                                                        .toLowerCase(); // monday, tuesday...

                                                      const isToday = item.day.toLowerCase() === today;

                                                      return (
                                                        index !== 0 && (
                                                          <Row className={isToday ? "bdho-active" : ""} key={index}>
                                                            <Col>
                                                              <p>
                                                                {item.day.charAt(0).toUpperCase() + item.day.slice(1)} 
                                                              </p>
                                                            </Col>
                                                            <Col>
                                                              <p>
                                                                  {!item.start_time ||
                                                                   !item.end_time ||
                                                                   item.start_time === "Closed"
                                                                    ? "Closed"
                                                                    : `${item.start_time} to ${item.end_time}`}
                                                                </p>
                                                            </Col>
                                                          </Row>
                                                        )
                                                      );
                                                    })}
                                                  </>
                                                )}
                                            </div>

                                    </Col>
                                    <Col md={12} lg={12} xl={6} className='bd-box-main'>
                                        <h4 className='my-3'>Current Deals</h4>
                                        <Row>
                                            {deal.map((val, index) => {
                                                return (
                                                    <Col xs={6} md={6} className='cd-single-main'>
                                                        <div className='cd-single-box'>
                                                            <Link to={`/neighbour/deal-details/${val.deal_id}`}>
                                                                        <Image 
                                                                            src={val.image && val.image !== "" ? val.image : process.env.REACT_APP_BASE_URL + 'assets/images/nif.jpg'} 
                                                                            className="img-fluid" 
                                                                            alt="cdeal" 
                                                                        />                                                                 
                                                                <div>
                                                                    {/* <h6>Seller : <Link to={`/neighbour/business-details/${val.slug}`}><span>{val.business_name}</span></Link></h6> */}
                                                                    {(() => {
                                                                        if (val.deal_master_type === 'specific') {
                                                                            if (val.deal_type === 1) {
                                                                                return (<div className='d-flex align-center csb-title'>
                                                                                    <div className='d-flex'><strike className="me-2"><h5>₹ {val.original_mrp}</h5></strike><h5>₹ {val.sale_price}</h5></div>
                                                                                    <h6 class="peroff">{val.discount}% off</h6>
                                                                                </div>)
                                                                            } else if (val.deal_type === 2) {
                                                                                return (<div className='d-flex align-center csb-title'>
                                                                                    <div className='d-flex'><h5>Buy {val.buy_qty} Get {val.get_qty}</h5></div>
                                                                                </div>)
                                                                            }
                                                                        } else if (val.deal_master_type === 'general') {
                                                                            if (val.deal_type === 3) {
                                                                                return (<div className='d-flex align-center csb-title'>
                                                                                    <div className='d-flex'><h5>{val.store_percent_discount}% OFF</h5></div>
                                                                                </div>)
                                                                            } else if (val.deal_type === 4) {
                                                                                return (<div className='d-flex align-center csb-title'>
                                                                                    <div className='d-flex'><h5>{val.store_cash_discount} OFF</h5></div>
                                                                                </div>)
                                                                            }
                                                                        } else if (val.deal_master_type === 'free') {
                                                                            return (<div className='d-flex align-center csb-title'>
                                                                                <div className='d-flex'><h5 className="text-danger">{val.free_item}</h5></div>
                                                                            </div>)
                                                                        }
                                                                    })()}
                                                                    <div className="title-box"><h5>{val.listing_title}</h5></div>
                                                                    <div className='cd-loc mt-2'>
                                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/pinpoint.webp'} className="img-fluid" alt="pinpoint" />
                                                                        <h6>{val.address}</h6>
                                                                    </div>
                                                                </div>
                                                            </Link>
                                                            <div className='dd-ld-box cd-ld-box'>
                                                                <Dropdown drop="up" onSelect={(eventKey) => handleLikeDislike(eventKey, val.deal_id, 'like')}>
                                                                    <Dropdown.Toggle className={`dd-like-box ${val.is_liked ? "like-box-bg" : "dlike-box-bg"}`} variant="success" id="dropdown-like">
                                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/like.webp'} className="img-fluid" alt="like" />
                                                                        <h6>{val.total_like}</h6>
                                                                    </Dropdown.Toggle>

                                                                    <Dropdown.Menu className='dd-like-drop'>
                                                                        {val.like.map((val1, index1) => {
                                                                            return (
                                                                                <Dropdown.Item className={val1.is_liked ? 'active-like' : ''} eventKey={val1.id}><div><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/like.webp'} className="img-fluid" alt="like" /> {val1.name} </div><span>{val1.like_count}</span></Dropdown.Item>
                                                                            );
                                                                        })}
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                                <Dropdown drop="up" onSelect={(eventKey) => handleLikeDislike(eventKey, val.deal_id, 'dislike')}>
                                                                    <Dropdown.Toggle className={`dd-dislike-box ${val.is_dis_liked ? "like-box-bg" : "dlike-box-bg"}`} variant="success" id="dropdown-dislike">
                                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/dislike.webp'} className="img-fluid" alt="dislike" />
                                                                        <h6>{val.total_dis_like}</h6>
                                                                    </Dropdown.Toggle>
                                                                    <Dropdown.Menu className='dd-dislike-drop'>
                                                                        {val.dislike.map((val1, index1) => {
                                                                            return (
                                                                                <Dropdown.Item className={val1.is_disliked ? 'active-dislike' : ''} eventKey={val1.id}><div><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/dislike.webp'} className="img-fluid" alt="dislike" /> {val1.name} </div><span>{val1.like_count}</span></Dropdown.Item>
                                                                            );
                                                                        })}
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                );
                                            })}
                                        </Row>
                                        {current_page !== last_page && (
                                            <Row className='text-center load-more'>
                                                <Col md={12}>
                                                    <Link to="#" className='blue-link' onClick={getdeal}>Load More</Link>
                                                </Col>
                                            </Row>
                                        )}
                                    </Col>
                                </Row>

                                <Row className="d-block d-sm-none">
                                    <Col md={12} lg={12} xl={6} className='bd-box-main'>
                                        <h4 className='my-3'>Contact Us</h4>

                                        <div className='bd-cont-single'>
                                            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/location.webp'} className="img-fluid" alt="location" />
                                            <p>{inputs.address}</p>
                                        </div>

                                        <div className='bd-cont-single'>
                                            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/email.webp'} className="img-fluid" alt="email" />    
                                            <p>{inputs.business_email}</p>
                                        </div>

                                        <div className='bd-cont-single'>
                                            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/phone.webp'} className="img-fluid" alt="phone" />
                                            <p>{inputs.business_contact_number}</p>
                                        </div>                                                                                

                                        <div className='bd-copy'>
                                            <Link to="#" onClick={handleCopy}>
                                                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/copy.webp'} className="img-fluid" alt="copy" />
                                                <p>Copy</p>
                                            </Link>
                                        </div>
                                       
                                        
                                        
                                        
                                        
                                        
                                        {inputs.latitude && inputs.longitude && (
                                          <>
                                            <h4 className="my-3">Map and Direction</h4>

                                            <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_API_KEY}>
                                              <GoogleMap
                                                mapContainerStyle={containerStyle}
                                                center={center}
                                                zoom={15}
                                              >
                                                <Marker position={center} />
                                              </GoogleMap>
                                            </LoadScript>
                                          </>
                                        )}


                                        {hoursofoperation.length > 0 && (
                                              <>
                                                <h4 className='my-3'>Hours of Operation</h4>

                                                    {hoursofoperation.map((item, index) => {
                                                      const today = new Date()
                                                        .toLocaleString("en-US", { weekday: "short" })
                                                        .toLowerCase(); // monday, tuesday...

                                                      const isToday = item.day.toLowerCase() === today;

                                                      return (
                                                        index !== 0 && (
                                                          <Row className={isToday ? "bdho-active" : ""} key={index}>
                                                            <Col>
                                                              <p>
                                                                {item.day.charAt(0).toUpperCase() + item.day.slice(1)} 
                                                              </p>
                                                            </Col>
                                                            <Col>
                                                              <p>
                                                                  {!item.start_time ||
                                                                   !item.end_time ||
                                                                   item.start_time === "Closed"
                                                                    ? "Closed"
                                                                    : `${item.start_time} to ${item.end_time}`}
                                                                </p>
                                                            </Col>
                                                          </Row>
                                                        )
                                                      );
                                                    })}
                                                  </>
                                                )}
                                                                                                                                                                                                                                                                                    
                                    </Col>
                                </Row>


                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            <Footer />
            {loading && (
                <div className="loadingClass">
                    <img src={loader} alt="loader" />
                </div>
            )}
        </>
    )
}

export default BussinessDetails;


